/* eslint-disable import/prefer-default-export */

export const careersSegmentEventCommonPropFunc = async () => ({
  page_type: 'careers',
})
